module.exports = __webpack_public_path__ + "img/fuente_de_alimentacion_conmutada.597da8c2.jpg";